import React from 'react'
import { useSignup } from './Signup.hooks'
import Nav from 'react-bootstrap/Nav'
import { ArrowRight } from 'react-bootstrap-icons'

const Stepper = () => {
  const { view, setView, stepAvailable } = useSignup()
  return (
    <div className='mb-5 signup__stepper'>
      <Nav justify variant="tabs" className="justify-content-center" activeKey={view} defaultActiveKey="billing" >
        <Nav.Item>
          <Nav.Link eventKey="billing" onClick={() => setView('billing')}>Rechnung</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="attendees" onClick={() => setView('attendees')} disabled={!stepAvailable('attendees')}>Teilnehmer</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="summary" onClick={() => setView('summary')} disabled={!stepAvailable('summary')}>Zusammenfassung</Nav.Link>
        </Nav.Item>
      </Nav>
    </div >
  )
}

export default Stepper
